export default __webpack_public_path__ + "static/media/250_ml.95ae8cd8.svg";